<template>
    <div>
        <div
            v-if="showing === 'loading'"
            :class="`mt-3 w-full text-white items-center inline-flex items-center py-3 px-4 border border-blue-600 border-transparent shadow-sm leading-4 rounded-md bg-gradient-to-r from-blue-500 to-${$root.theme}-500`">
            <svg class="w-10 h-10 w-full fa-spin" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                 xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
            </svg>
        </div>
        <a
            v-if="showing === 'download'"
            @click.prevent="download"
            style="height: 66px"
            :class="`mt-3 w-full text-white items-center inline-flex items-center py-3 px-4 border border-blue-600 border-transparent shadow-sm leading-4 rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 bg-blue-500 hover:bg-blue-600 focus:ring-blue-300 cursor-pointer bg-gradient-to-r from-blue-500 to-${$root.theme}-500`">
            <div class="text-lg mr-4">
                <i class="fa fa-envelope-o fa-fw"></i>
            </div>
            <div class="text-sm text-left">
                Click here to download your release letter.
            </div>
        </a>
        <form
            v-if="showing === 'form'"
            @submit="submitEmail"
            :class="`mt-3 w-full text-white items-center inline-flex items-center py-3 px-4 border border-blue-600 border-transparent shadow-sm leading-4 rounded-md  bg-gradient-to-r from-blue-500 to-${$root.theme}-500`">
            <div class="text-sm text-left w-full">
                <div class="mb-2 w-full">Enter email address to receive your release letter:</div>
                <input
                    name="release-letter-email"
                    type="email"
                    v-model="emailAddress"
                    class="py-3 px-4 rounded bg-gray-50 relative block w-full rounded-none rounded-bl-md bg-transparent focus:z-10 sm:text-sm focus:ring-blue-400 mb-2 focus:border-blue-400 border-gray-300 text-black"
                    placeholder="Email Address" required>

                <small class="text-xs mb-2">
                    By entering your email you're authorizing us to send you your release letter.
                </small>

                <button type="submit"
                        class="mt-4 w-full justify-center text-black items-center inline-flex items-center px-3 pt-4 pb-3 border border-transparent border-gray-300 shadow-sm leading-4 font-medium rounded-md bg-gray-50 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-200">
                    Send Release Letter
                </button>

            </div>
        </form>
        <div
            v-if="showing === 'confirmation'"
            :class="`mt-3 w-full text-white items-center inline-flex items-center py-3 px-4 border border-blue-600 border-transparent shadow-sm leading-4 rounded-md  bg-gradient-to-r from-blue-500 to-${$root.theme}-500`">
            <div class="text-sm text-left w-full">
                We have sent your release letter to: <strong>{{ emailAddress }}</strong>. Please check your spam folder
                if you do not receive it.
            </div>
        </div>
        <div
            v-if="showing === 'downloaded'"
            :class="`mt-3 w-full text-white items-center inline-flex items-center py-3 px-4 border border-blue-600 border-transparent shadow-sm leading-4 rounded-md  bg-gradient-to-r from-blue-500 to-${$root.theme}-500`">
            <div class="text-sm text-left w-full">
                Your release letter download will start momentary.
            </div>
        </div>
    </div>
</template>

<script>
import Mixins from "../../mixins";
import PdoMixin from "../../mixins/Pdo";

export default {

    props: ['account', 'data'],
    data() {
        return {
            showing: 'download',
            emailAddress: null
        }
    },

    methods: {
        download() {
            window.open(`${this.data.consumerPortalBaseUrl}/download-release-letter`, '_blank');
        },
        submitEmail() {
            this.showing = 'loading';

            this.$http.post(`${this.data.consumerPortalBaseUrl}/api/send-release-letter`, {
                email: this.emailAddress
            }).then(
                r => {
                    this.showing = 'confirmation'
                },
                error => {
                    alert('There was an error sending your release letter');
                    this.showing = 'form';
                }
            )
        }
    }
}
</script>
